import type { Variant } from '@storefront/lib-global/codegen/types';

export const removeDuplicateReducer =
  <K extends keyof Variant>(type: K) =>
  (acc: string[], variant: Variant) => {
    const value = variant[type];
    if (typeof value === 'string' && value !== '' && !acc.includes(value)) {
      return [...acc, value];
    }
    return acc;
  };
